import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import EnquiryForm from "../components/EnquiryForm";

const EnquiryContext = createContext({ openEnquiry: () => {} });

export const EnquiryProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, tour: "", type: "tour" });

  const openEnquiry = (tour = "", type = "tour") => setState({ open: true, tour, type });
  const close = () => setState((s) => ({ ...s, open: false }));

  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <Dialog open={state.open} onOpenChange={(o) => !o && close()}>
        <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto rounded-2xl p-6 sm:p-8" data-testid="enquiry-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-pine">
              {state.type === "custom" ? "Customize Your Experience" : "Request a Tour"}
            </DialogTitle>
            <DialogDescription>
              Send us your wishes — we reply personally with availability and a no-obligation quote. No payment is taken online.
            </DialogDescription>
          </DialogHeader>
          <EnquiryForm defaultTour={state.tour} type={state.type} onDone={close} />
        </DialogContent>
      </Dialog>
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);
